import React from "react";
import { useSelector } from "react-redux";
import { getIndexCampaigns } from "store/indexCampaigns/selectors";
import Frame from "components/elements/Frame/Frame";
import Container from "components/elements/Container";
import { FlightCampaignTCBanner } from "components/elements/FlightCampaignTCBanner";

export function GeniusFlightsHomeBanner() {
  const { genius: geniusCampaign } = useSelector(getIndexCampaigns);

  if (!geniusCampaign) {
    return null;
  }

  return (
    <Container>
      <Frame mt={6} mb={8}>
        <FlightCampaignTCBanner campaignBanner={geniusCampaign} />
      </Frame>
    </Container>
  );
}
